(function ($) {
    "use strict";
    $(function () {

        // Utility function to animate the count-up, keeping the "Ft" postfix
        function countUp($element, start, end, duration) {
            let range = end - start;
            let startTime = null;

            function step(timestamp) {
                if (!startTime) startTime = timestamp;
                let progress = timestamp - startTime;
                let currentValue = Math.min(start + (progress / duration) * range, end);
                $element.text(number_format(Math.floor(currentValue), 0, ',', ' ') + ' Ft'); // Update with formatted number and "Ft" postfix
                if (progress < duration) {
                    window.requestAnimationFrame(step);
                } else {
                    $element.text(number_format(end, 0, ',', ' ') + ' Ft'); // Ensure the final value is set
                }
            }

            window.requestAnimationFrame(step);
        }

        // Helper function to format numbers like PHP's number_format
        function number_format(number, decimals, dec_point, thousands_sep) {
            let n = !isFinite(+number) ? 0 : +number,
                prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
                sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
                dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
                s = '',
                toFixedFix = function (n, prec) {
                    let k = Math.pow(10, prec);
                    return '' + Math.round(n * k) / k;
                };
            // Fix for IE parseFloat(0.55).toFixed(0) = 0;
            s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
            if (s[0].length > 3) {
                s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
            }
            if ((s[1] || '').length < prec) {
                s[1] = s[1] || '';
                s[1] += new Array(prec - s[1].length + 1).join('0');
            }
            return s.join(dec);
        }

        // Function to get all last updates via AJAX
        function getAllLastUpdates() {
            let casinoId = $(this).find('.js-jackpot-update-data').data('id');
            $.ajax({
                url: localize.ajaxurl,
                type: 'POST',
                data: {
                    action: 'lvc_casino_jackpot_last_update',
                    casino: casinoId,
                },
                success: function (response) {
                    if (response.success) {
                        let updates = response.data;

                        // Loop through each card and update the last update text
                        $('.js-jackpot-update-data').each(function () {
                            let $lastUpdateElement = $(this).find('.js-last-update-text');

                            if (updates) {
                                $lastUpdateElement.text(updates);
                            } else {
                                $lastUpdateElement.text('No data available');
                            }
                        });
                    } else {
                        $('.js-last-update-text').text('No data available');
                    }
                },
                error: function () {
                    $('.js-last-update-text').text('Error fetching data');
                }
            });
        }

        // Function to get all jackpot values via AJAX
        function getAllJackpotValues() {
            $.ajax({
                url: localize.ajaxurl,
                type: 'POST',
                data: {
                    action: 'lvc_casino_jackpot_value'
                },
                success: function (response) {
                    if (response.success) {
                        let jackpots = response.data;

                        // Loop through each card and update the jackpot value
                        $('.js-jackpot-data').each(function () {
                            let casinoId = $(this).data('id'); // Get the casino id from data attributes
                            let jackpotType = $(this).data('type'); // Get the type of jackpot

                            let $jackpotElement = $(this).find('.js-jackpot-text'); // Jackpot display element

                            if (jackpots[casinoId] && jackpots[casinoId][jackpotType]) {
                                let jackpotValue = jackpots[casinoId][jackpotType];
                                let numericalJackpotValue = parseInt(jackpotValue.replace(/\D/g, '')); // Remove non-numeric chars

                                // Extract the current value from the DOM, stripping "Ft" and formatting
                                let currentJackpotValue = parseInt($jackpotElement.text().replace(/\D/g, '')) || 0;

                                // Use the countUp function for a smooth transition, preserving the "Ft" postfix
                                countUp($jackpotElement, currentJackpotValue, numericalJackpotValue, 2000); // Count up over 2 seconds
                                $(this).parent().addClass('active'); // Add active class to show the element
                            } else {
                                $jackpotElement.text('0 Ft'); // Default value if no data
                            }
                        });
                    } else {
                        $('.js-jackpot-text').text('0 Ft');
                    }
                },
                error: function () {
                    $('.js-jackpot-text').text('Error fetching data');
                }
            });
        }

        // Function to handle intersection observer logic
        function observeJackpotElement() {
            const options = {
                root: null, // viewport
                rootMargin: '0px',
                threshold: 0.1 // Trigger when 10% of the element is visible
            };

            const observer = new IntersectionObserver((entries, observer) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        getAllLastUpdates();
                        // Run the function to get jackpot values when element is in view
                        getAllJackpotValues();
                        // Optionally stop observing after it has been observed once
                        observer.unobserve(entry.target);
                    }
                });
            }, options);

            // Target the .js-jackpot element for observation
            const jackpotElement = document.querySelector('.js-jackpot-wrapper');
            if (jackpotElement) {
                observer.observe(jackpotElement);
            }
        }

        // Initialize the observer
        observeJackpotElement();

    });
})(jQuery);
